  <div class="editor-choice-card mb-2" *ngIf="editorChoiceCard.product_type === productType.EDITORS_CHOICE">
    <div class="px-3" [style.background-image]="this.editorChoiceCard.products[0].headers?.color | gradient: gradientDirection.BOTTOM : '0%': '94px'">
      <div class="editor-choice-badging-box">
        <span class="editor-choice-badging d-flex align-items-center">
          <img loading="lazy" class="editor-choice-icon mr-1" [src]="editorChoiceCard.products[0].headers.images.icon" alt="EC Badge" />
          <span class="editor-choice-title heading-4">
            {{editorChoiceCard.products[0].headers.highlight_text}}
          </span>
        </span>
        <img loading="lazy" class="editor-choice-banner" [src]="editorChoiceCard.products[0].headers.images.right.gr" alt="EC Banner" />
      </div>
      <div>
        <p class="heading-4 mt-3">
          <span class="cursor-pointer " (click)="viewDetails();sendAnalyticEvents(actionOn.INSIGHT_COLLECTOR, ctaType.CARD)">
            {{editorChoiceCard.products[0].title}}
          </span>
        </p>
        <p class="secondary-paragraph mt-2">
          <span class="cursor-pointer color-grey-700" (click)="viewDetails();sendAnalyticEvents(actionOn.INSIGHT_COLLECTOR, ctaType.CARD)">
            {{this.editorChoiceCard.products[0].description | textTruncate : numericValue.ONE_SEVENTY}}
          </span>
          <span *ngIf="editorChoiceCard.products[0].description.length > numericValue.ONE_SEVENTY" 
            class="d-inline-block cursor-pointer secondary-paragraph-bold"
            (click)="viewDetails(); sendAnalyticEvents(actionOn.VIEW_MORE, ctaType.TEXT);">
          <span class="">{{mls.languageText.editor_choice.key4}}</span>
        </span>
        </p>
        <ul class="mt-1">
          <li class="secondary-paragraph d-inline-block cursor-pointer mr-2 pr-1" *ngFor="let specialty of editorChoiceCard.products[0].specialities">
            <span class="color-grey-500"  (click)="getSpecialty(specialty)">
              #{{specialty.speciality_name}}
            </span>
          </li>
        </ul>
        <div class="clearfix mt-4 cursor-pointer d-flex align-items-center" (click)="navigateToUser(); profilePicClicked()">
          <span class="mr-2 editor-choice-profile-pic">
            <img
              [src]="editorChoiceCard.products[0].user_profile.profile_pic"
              onerror="this.src='assets/themes/icons/user-profile-placeholder.svg'"
              class="h-100 w-100"
              alt="Profile pic" />
          </span>
          <div>
            <p class="paragraph-bold">
              <span>{{editorChoiceCard.products[0].user_profile.full_name}}</span></p>
            <span class="secondary-paragraph">{{editorChoiceCard.products[0].designation}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="custom-owl-carousel p-0 shadow-none bg-none mt-2" *ngIf="editorChoiceCard.products[0].ec_products.length > numericValue.ONE">
      <owl-carousel-o [options]="customOptions">
        <ng-template carouselSlide *ngFor="let item of editorChoiceCard.products[0].ec_products">
          <div class="editor-choice-container">
            <app-editor-choice-highlights
              appear
              [callingfrom]="callingfrom"
              [horizontal]="true"
              [rootMargin]="fcs.margin.ICCurrentHRootMargin"
              [appearIds]="getAppearedIds(item)"
              (appearedCards)="onCardAppear($event)"
              [editorChoiceSlideContent]="item"
              (feedSpecialty)="feedListFilteredBySpecialty($event)"
              [ecId]="this.editorChoiceCard.products[0].product_type_id"></app-editor-choice-highlights>
          </div>
        </ng-template>
      </owl-carousel-o>
  </div>
    <div class="mt-2"
      [ngClass]="{'editor-choice-single' : editorChoiceCard.products[0].ec_products.length === numericValue.ONE}"
      *ngIf="editorChoiceCard.products[0].ec_products.length === numericValue.ONE">
      <app-editor-choice-highlights
        appear
        [horizontal]="true"
        [callingfrom]="callingfrom"
        [rootMargin]="fcs.margin.ICCurrentHRootMargin"
        [appearIds]="getAppearedIds(editorChoiceCard.products[0].ec_products[0])"
        (appearedCards)="onCardAppear($event)"
        [editorChoiceSlideContent]="editorChoiceCard.products[0].ec_products[0]"
        [ecId]="this.editorChoiceCard.products[0].product_type_id"
        (feedSpecialty)="feedListFilteredBySpecialty($event)"></app-editor-choice-highlights>
    </div>
    <div *ngIf="this.mls.featureOnOffList.featureList.bookmark.value || !mls.userLoginFlow" class="editor-choice-buttons d-flex align-items-center justify-content-center">
      <span [ngClass]="{'active': editorChoiceCard.products[0]?.is_bookmarked === numericValue.ONE}"
        (click)="productBookmark()" class="editor-choice-bookmark d-flex align-items-center justify-content-center cursor-pointer">
        <img src="assets/themes/images/primary-loader.gif"
          class="cursor-pointer"
          width="25"
          *ngIf="ec_bookmark_loader"
          alt="loader"/>
        <img src="assets/themes/icons/bookmark-white.svg"
          class="cursor-pointer"
          *ngIf="editorChoiceCard.products[0]?.is_bookmarked !== numericValue.ONE && ec_bookmark_loader === false"
          alt="bookmark post"/>
        <img src="assets/themes/icons/bookmark-black.svg"
          class="cursor-pointer"
          *ngIf="editorChoiceCard.products[0]?.is_bookmarked === numericValue.ONE && ec_bookmark_loader === false"
          alt="bookmarked post"/>

        <span class="ml-2 button">
          <span class="color-grey-700" *ngIf="!(editorChoiceCard.products[0]?.is_bookmarked === numericValue.ONE)">{{editorChoiceCard.products[0]?.is_bookmarked ? mls.languageText.editor_choice.key2: mls.languageText.editor_choice.key1}}</span>
          <span *ngIf="editorChoiceCard.products[0]?.is_bookmarked === numericValue.ONE">{{editorChoiceCard.products[0]?.is_bookmarked ? mls.languageText.editor_choice.key2: mls.languageText.editor_choice.key1}}</span>
        </span>
      </span>
      <span class="editor-choice-bookmark d-flex align-items-center justify-content-center" *ngIf="editorChoiceCard.products[0].ec_products.length > numericValue.ONE">
        <button
          class="btn-design medium outline"
          (click)="viewDetails();sendAnalyticEvents(actionOn.VIEW_ALL, ctaType.BUTTON);">
          {{mls.languageText.editor_choice.key3}} <img class="mb-1" src="assets/themes/icons/small-arrow.svg" alt="Arrow Icon" />
        </button>
    </span>
    </div>
  </div>